import React from 'react';
import PropTypes from 'prop-types';
import { Select, FormItem } from 'formik-antd';
import { Fieldset } from 'components/form';
import { Button, Divider } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { simpleFilterOptions } from 'utils/form';
import { RolesBySector, sectors } from 'utils/roles-sectors';
import { DB_PREFIX_JOBS as DB_PREFIX } from '../constants';
import StagePropTypes from '../prop-types';

import './style.css';

const Row = ({ arrayHelpers, values, setFieldValue, i }) => {
  const prefix = 'job-role';

  const { sector } = values[DB_PREFIX][i];

  return (
    <>
      <div className={`${prefix}-input-wrapper`} key={i}>
        <FormItem label="Job Sector" name={`${DB_PREFIX}.${i}.sector`}>
          <Select
            name={`${DB_PREFIX}.${i}.sector`}
            placeholder="Please select the sector of your job role"
            showSearch
            filterOption={simpleFilterOptions}
            allowClear
            onChange={() => {
              setFieldValue(`${DB_PREFIX}.${i}.role`, null);
            }}
          >
            {sectors.map(({ name, label }, j) => (
              <Select.Option key={`${i}-${name}-${j}`} value={name}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </FormItem>

        {sector != null ? (
          <FormItem name={`${DB_PREFIX}.${i}.role`} label="Job Role">
            <Select
              name={`${DB_PREFIX}.${i}.role`}
              placeholder="Please select your job role"
              showSearch
              filterOption={simpleFilterOptions}
              allowClear
            >
              {RolesBySector(sector).map(({ name, label }, j) => (
                <Select.Option key={`${j}-${name}-${i}`} value={name}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        ) : null}
        <Button
          type="danger"
          className="dynamic-delete-button"
          onClick={() => arrayHelpers.remove(i)}
        >
          <MinusCircleOutlined className="dynamic-delete-button" />
        </Button>
      </div>

      <Divider />
      {i === values[DB_PREFIX].length - 1 ? (
        <Fieldset>
          <Button
            style={{ width: '100%' }}
            type="dashed"
            onClick={() =>
              arrayHelpers.push({
                sector: null,
                role: null,
              })
            }
          >
            <PlusCircleOutlined /> Add job role
          </Button>
        </Fieldset>
      ) : null}
    </>
  );
};

Row.propTypes = {
  i: PropTypes.number.isRequired,
  arrayHelpers: PropTypes.shape({
    push: PropTypes.func,
    remove: PropTypes.func,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
};

export default Row;
